import { ERP_GET_EXE } from "../../../helpers/fakebackend_helper";

import { createAsyncThunk } from "@reduxjs/toolkit";

export const GET_EXE_FILE = createAsyncThunk(
  "erpgetexe/get",
  async (thunkAPI) => {
    try {
      const response = ERP_GET_EXE();
      const data = await response;
      console.log(data);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
